import React, { FC } from 'react';
import { ItemProps } from '../../types';

const Divider: FC<ItemProps> = ({ formItem }) => {
	return (
		<div
			className={`w-full border-t border-t-gray-300`+
				`${formItem.classNames?.content || ""} `
			}
		></div>
	);
};

export default Divider;